import { render, staticRenderFns } from "./RelationList.vue?vue&type=template&id=5033e310&scoped=true"
import script from "./RelationList.vue?vue&type=script&lang=ts"
export * from "./RelationList.vue?vue&type=script&lang=ts"
import style0 from "./RelationList.vue?vue&type=style&index=0&id=5033e310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5033e310",
  null
  
)

export default component.exports